export const CloseYellowIcon = ({
  strokeColor = "var(--color-yellow)",
  ...props
}: any) => (
  <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none">
    <g id="Icons All" clipPath="url(#clip0_290_3651)">
      <path
        id="Vector"
        d="M2.19667 2.81798L9.26773 9.88905M2.19667 9.88905L9.26773 2.81798"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_290_3651">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
